import { render, staticRenderFns } from "./EntityPageTabs.vue?vue&type=template&id=2e8d1a43&scoped=true&"
import script from "./EntityPageTabs.vue?vue&type=script&lang=js&"
export * from "./EntityPageTabs.vue?vue&type=script&lang=js&"
import style0 from "./EntityPageTabs.vue?vue&type=style&index=0&id=2e8d1a43&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8d1a43",
  null
  
)

export default component.exports